export function downloadImage(url, disableCache = false) {
  if (!url?.length) return;

  const fetchUrl = `${url}${disableCache ? `?dummy=${Math.floor(Date.now())}` : ''}`;

  fetch(fetchUrl, {
    method: 'GET',
    headers: {}
  })
    .then((response) => {
      response.arrayBuffer().then(function (buffer) {
        const linkUrl = window.URL.createObjectURL(new Blob([buffer]));
        const link = document.createElement('a');

        link.href = linkUrl;
        link.setAttribute('download', url.substr(url.lastIndexOf('/') + 1));
        document.body.appendChild(link);
        link.click();
      });
    })
    .catch((error) => {
      console.warn(error);
      return error;
    });
}
